module.exports = __webpack_public_path__ + "static/media/icon_arrow_white_right.6c74ad52.svg";